// Where a popup (a menu, a picker, a card) goes by what opened it: below
// it, or above when it does not fit below and fits better above; lined up
// with its start or end edge, or centered on it, moved in to stay on screen; and no taller
// than the room it has, so it scrolls rather than running off.

export interface Box {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export interface Placement {
  top: number;
  left: number;
  maxHeight: number;
  // side is where it went, so it can grow from there.
  side: "below" | "above";
}

export interface PlaceOptions {
  side?: "below" | "above";
  align?: "start" | "end" | "center";
  gap?: number;
  margin?: number;
}

export function place(anchor: Box, size: { width: number; height: number }, view: { width: number; height: number }, { side = "below", align = "start", gap = 6, margin = 8 }: PlaceOptions = {}): Placement {
  const below = view.height - margin - (anchor.bottom + gap);
  const above = anchor.top - gap - margin;
  const fits = (room: number) => size.height <= room;
  const chosen = side === "below" ? (fits(below) || below >= above ? "below" : "above") : fits(above) || above >= below ? "above" : "below";
  const room = Math.max(0, chosen === "below" ? below : above);
  const height = Math.min(size.height, room);
  const top = chosen === "below" ? anchor.bottom + gap : anchor.top - gap - height;
  const wanted = align === "start" ? anchor.left : align === "end" ? anchor.right - size.width : (anchor.left + anchor.right - size.width) / 2;
  const left = Math.max(margin, Math.min(wanted, view.width - margin - size.width));
  return { top, left, maxHeight: room, side: chosen };
}
